export default __webpack_public_path__ + "static/media/login-bg-2.d331b87e.jpg";